<template>
  <div v-if="contract.id" class="form-detail">
    <h1>Thông tin MC</h1>
    <Content title="Tên Merchant" :content="item.merchantName"></Content>
    <Content title="Tên viết tắt MC" :content="item.businessShortName"></Content>
    <Content title="Email" :content="item.email"></Content>
    <Content title="Số điện thoại" :content="item.mobile"></Content>
    <Content title="Địa chỉ">
      {{ item.address }}, {{ item?.ward }}, {{ item.district }}, {{ item.city }}
    </Content>
    <Content
      v-if="['COMPANY', 'HOUSEHOLD'].includes(item.customerType)"
      title="MST/ ĐKKD"
      :content="item.businessRegistrationNumber"
    ></Content>
    <Content title="Website" :content="item.website"></Content>
    <Content v-if="item.referSource" title="Nguồn MC">
      {{ item.referSource | findIdText(listCTVSource) }}
    </Content>
    <Content title="CTV">
      {{ agentInfo.name }}
      <span v-if="agentInfo.mobile"> - {{ agentInfo.mobile }}</span>
      <span v-if="agentInfo.email"> - {{ agentInfo.email }}</span>
    </Content>
    <Content v-if="item.businessFieldAmount" title="Giá trị trung bình">
      {{ item.businessFieldAmount | transformNumber }}
    </Content>
    <Content v-if="item.ownPOS" title="Đã sử dụng POS bên khác?">
      {{ item.ownPOS | transformData(Config.ownPOS) }}
    </Content>
    <Content v-if="item.lstPos" title="POS bên nào?">
      {{ item.lstPos ? item.lstPos.map(pos => (pos === 'OTHER' ? 'Khác' : pos)).join(', ') : '' }}
    </Content>
    <Content v-if="item.finDocStt" title="Tình trạng chứng từ">
      {{ item.finDocStt | transformData(Config.finDocStt) }}
    </Content>
    <Content title="Thương hiệu" :content="item.brand"></Content>
    <Content
      title="Sở hữu nhãn hiệu"
      :content="item.brandOwnerType | transformData(Config.mcKeyOwnerType)"
    ></Content>
    <Content title="Cấp bậc MC">
      <Status :value="item.mcLvl" :config="Config.mcKeyLvl" />
    </Content>
    <Content v-if="contract.depositType" title="Ngành hàng">
      {{ item.mccName }}
      <a
        v-if="
          contract.state === 'SIGNED_WAITING_APPROVED' &&
          canAccessMx('CNPS_CSTM_MERCHANT_UPDATE') &&
          ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(dataUser.typeSale)
        "
        href="javascript:;"
        class="float-right f12"
        @click="updateMcc"
      >
        Sửa ngành hàng
      </a>
    </Content>
    <Content title="Ngành nghề chi tiết" :content="item.mccDetail"></Content>
    <Content title="Loại hình DN" :content="item.businessField"></Content>
    <modalEditMcc
      v-if="canEditMcc"
      :systemConfig="systemConfig"
      @updateInfo="updateInfo"
      :closeModal="closeModal"
    />
  </div>
</template>

<script>
  import Content from './Content.vue'
  import Config from '@/thirdParty/config'
  import modalEditMcc from '../modal-edit-mcc/modal-edit-mcc.vue'
  import { CommonService } from '@/services/common.service'
  export default {
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      contract: {
        type: Object,
        default: () => {},
      },
      canEditMcc: {
        type: Boolean,
        default: false,
      },
      dataConfigMcc: {
        type: Array,
        default: () => {},
      },
      submitEditMcc: {
        type: Function,
      },
    },
    components: { Content, modalEditMcc },
    data() {
      return {
        Config,
        listCTVSource: [
          { id: 'DIRECT_SALES', text: 'DirectSales' },
          { id: 'AGENCY', text: 'Cộng tác viên' },
          { id: 'MARKETING', text: 'Marketing' },
          { id: 'TELESALE', text: 'Tele Sale' },
          { id: 'SALES', text: 'Sales' },
        ],
        systemConfig: {
          businessFields: [],
          baseMccDetail: [],
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
      }
    },
    computed: {
      agentInfo() {
        return this.contract.agentInfo ?? {}
      },
    },
    created() {
      this.getConfigSystem()
    },
    methods: {
      updateMcc() {
        this.canEditMcc = true
        this.$nextTick(s => this.$bvModal.show('edit-mcc'))
      },
      closeModal() {
        this.$bvModal.hide('edit-mcc')
        this.canEditMcc = false
      },
      getConfigSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              const config = data.data
              this.systemConfig = {
                businessFields: this.map(config.businessFields),
                baseMccDetail: config.mccDetail,
              }
            }
          })
          .catch(error => console.log(error))
      },
      map(items, id = 'code', text = 'name') {
        return items.map(e => ({ id: e[id], text: e[text] }))
      },
      async updateInfo(data) {
        if (data.mcc === '') {
          this.showFailMx('Thông tin nghành nghề không được để trống')
        } else if (data.mccDetail === '') {
          this.showFailMx('Thông tin nghành nghề chi tiết không được để trống')
        } else await this.submitEditMcc(data.mcc, data.mccDetail)
      },
    },
  }
</script>

<style scoped></style>
